import fig1 from './fig1.svg';
import fig2 from './fig2.svg';
import React from "react";


export default function Header() {
    return (
        <div className="container m-1rem" >
            <header className="row justify-content-xl-center " >
                <div className="container col-md" style={{ marginTop: '2rem' }}>
                    <h2>
                        Hip Joint Reaction Force -
                    </h2>
                    <h3>
                        a Simple Calculator
                    </h3>
                    <p></p>
                    <p>
                        It is assumed that the pivot leg is vertical to the ground and pelvis is either horisontal or rotated relative to the hip in the coronal plane.
                    </p>
                    <p>
                        Values in the form fields are default: enter your own values to change results. Scroll down after pressing 'Calculate'.
                    </p>
                    <p>
                        Currently, the app does not take into account the natural relationship between the angle of the hip rotation (beta) and the angle of the average abductor force (alpha) so one cannot be inferred from the other.
                    </p>
                </div>
                <div className="col-lg">
                    <img src={fig1} alt="fig1" />
                </div>
                <div className="col-lg">
                    <img src={fig2} alt="fig2" />
                </div>
            </header>

        </div>
    )
}

